import { Routes } from '@angular/router';
import { B2CRedirectComponent } from '../core/auth/components/b2c-redirect.component';
import { authGuard } from '@core/auth/guards/auth.guard';
import { navigateByNavigationPathGuard } from '@core/navigation/guards/navigate-by-navigation-path.guard';
import { replaceUrlToTokenGuard } from '@core/navigation/guards/replace-url-to-token.guard';
import { testEnvOnlyGuard } from '@core/navigation/guards/test-env-only.guard';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { reducers as kanbanReducers } from './main-kanban/store';
import { FEATURE_NAME as kanbanFeature } from './main-kanban/store/state';
import { KanbanEffects } from './main-kanban/store/effects';
import { DefaultKanbanDataService, KANBAN_SERVICE_TOKEN } from './main-kanban/services/kanban-data.service';

export const routes: Routes = [
  {
    path: 'auth',
    component: B2CRedirectComponent,
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: 'test-form',
        loadComponent: () => import('./test-form/test-form.component').then((m) => m.TestFormComponent),
        pathMatch: 'full',
        canActivate: [testEnvOnlyGuard],
      },
      {
        path: 'entity/:entityId/record/:recordId',
        redirectTo: 'entity/:entityId/record/:recordId/form/',
        pathMatch: 'full',
      },
      {
        path: 'form/:formId',
        loadComponent: () => import('./main-form/main-form.component').then((m) => m.MainFormComponent),
        canActivate: [replaceUrlToTokenGuard],
      },
      {
        path: 'entity/:entityId/record/:recordId/form/:formId',
        loadComponent: () => import('./main-form/main-form.component').then((m) => m.MainFormComponent),
        canActivate: [replaceUrlToTokenGuard],
      },
      {
        path: 'entity/:entityId',
        redirectTo: 'entity/:entityId/view/',
        pathMatch: 'full',
      },
      {
        path: 'entity/:entityId/view/:viewId',
        loadComponent: () => import('./main-view/main-view.component').then((m) => m.MainViewComponent),
        canActivate: [replaceUrlToTokenGuard],
      },
      {
        path: 'entity/:entityId/kanban/:kanbanId',
        loadComponent: () => import('./main-kanban/main-kanban.component').then((m) => m.MainKanbanComponent),
        providers: [
          provideState(kanbanFeature, kanbanReducers),
          provideEffects(KanbanEffects),
          { provide: KANBAN_SERVICE_TOKEN, useExisting: DefaultKanbanDataService },
        ],
        canActivate: [replaceUrlToTokenGuard],
      },
      {
        path: 'entity/:entityId/form',
        redirectTo: 'entity/:entityId/form/',
        pathMatch: 'full',
      },
      {
        path: 'entity/:entityId/form/:formId',
        loadComponent: () => import('./main-form/main-form.component').then((m) => m.MainFormComponent),
        canActivate: [replaceUrlToTokenGuard],
      },
      {
        path: ':navigationPath/customizations',
        loadComponent: () =>
          import('./main-customization-panel/main-customization-panel.component').then(
            (m) => m.MainCustomizationPanelComponent,
          ),
        children: [],
        canActivate: [navigateByNavigationPathGuard],
      },
      {
        path: ':navigationPath',
        children: [],
        canActivate: [navigateByNavigationPathGuard],
      },
    ],
  },
];
